import PropTypes from 'prop-types';
import React from 'react';
import { errorPropType } from '../../constants';
import { useSendErrorContext } from '../../hooks';
import CollapsibleErrorView from '../CollapsibleErrorView';
const ContextCollapsibleError = ({ error, sendErrorCallback, ...other })=>{
    const sendErrorContext = useSendErrorContext(sendErrorCallback);
    const { sentSuccess, sentFail } = error;
    const isSent = sentSuccess || sentFail;
    return /*#__PURE__*/ React.createElement(CollapsibleErrorView, {
        error: error,
        onSendError: sendErrorContext,
        isError: sentFail,
        isSent: isSent,
        ...other
    });
};
ContextCollapsibleError.propTypes = {
    error: errorPropType.isRequired,
    sendErrorCallback: PropTypes.func
};
export default ContextCollapsibleError;
